<template>
  <v-container>
    <section class="mt-2 mb-10">
      <h1 v-if="me" class="font-size--24">사업장의 매출을 분석한 당겨받기 한도입니다.</h1>
    </section>
    <GetOffer
      :loading.sync="getOfferLoading"
      :offer.sync="offer"
      :options="componentGetOffer.options"
      @update:offer="handleOfferUpdate"
    >
      <div></div>
    </GetOffer>

    <section class="mb-10">
      <p class="font-size--18 color--nice-grey font-weight-bold mb-0">미리 받을 수 있는 매출은</p>
      <h1 class="font-size--35 font-weight-black">
        <v-layout :justify-center="!offer || offer.amount === 0">
          <v-fade-transition hide-on-leave>
            <!-- 오퍼 없거나 상태가 미완료일때 -->
            <v-progress-circular
              v-if="isOfferInProgress"
              size="36"
              class="my-2"
              color="grey"
              indeterminate
            />

            <!-- 가능 금액 없을 때 -->
            <span v-else-if="offer && offer.amount === 0"> - 원 </span>

            <!-- 한도 산출 완료 -->
            <span v-else> {{ commaFormat(offer.amount) }} 원 </span>
          </v-fade-transition>
        </v-layout>
      </h1>
    </section>

    <section class="mb-4">
      <!-- 오퍼의 상태가 미완료일때 -->
      <BasicButton v-if="isOfferInProgress" depressed height="48" disabled>
        한도 산출 중
      </BasicButton>

      <!-- 한도 산출 완료 -->
      <BasicButton
        v-else
        depressed
        height="48"
        :disabled="!isLoanRequestable || requestLoanLoading"
        :loading="requestLoanLoading"
        @click="request"
      >
        {{ isLoanRequestable ? '미래매출 당겨받기' : `신청 시간 ${startHour}시 ~ ${endHour}시` }}
      </BasicButton>
    </section>

    <section>
      <ul class="font-size--14 color--nice-grey outer">
        <li>미래매출 당겨받기는 P2P 방식으로 온라인 모집하여 지급합니다.</li>
        <li>모집 기간은 5일이며, 신청하신 금액 중 일부만 모집-지급될 수 있습니다.</li>
      </ul>
    </section>

    <v-footer fixed>
      <v-layout justify-center>
        <v-btn
          text
          color="grey"
          height="25"
          :disabled="requestLoanLoading"
          style="text-decoration: underline"
          :to="'/'"
        >
          돌아가기
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { commaFormat } from '@/filter/number'
import { locationRedirect } from '@/util'

export default {
  data() {
    return {
      componentGetOffer: {
        options: {
          repayment_period_in_days: 120,
          loan_type: 'normal',
        },
      },
      offer: null,
      requestLoanLoading: false,
      getOfferLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('loan', ['loanAvailableTime']),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'isLoanAvailableTime',
      'investingPullRevenue',
    ]),
    startHour() {
      const result = this.loanAvailableTime
        ? Number(this.loanAvailableTime.startHour.split(':')[0])
        : ''
      const hour = 12
      return result > hour ? `오후 ${result - hour}` : `오전 ${result}`
    },
    endHour() {
      const result = this.loanAvailableTime
        ? Number(this.loanAvailableTime.endHour.split(':')[0])
        : ''
      const hour = 12
      return result > hour ? `오후 ${result - hour}` : `오전 ${result}`
    },
    isLoanRequestable() {
      return this.isPullRevenueOfferRequest && this.offer && this.offer.amount >= 100000
    },
    isOfferInProgress() {
      if (!this.offer) return true
      return this.offer.status === 'in_progress'
    },
  },
  async created() {
    _meta({
      titles: ['당겨받기'],
    })

    try {
      // console.log('validateUserRequirements1')

      // await this.validateUserRequirements1()

      // console.log('this.$route.query', this.$route.query)

      // 기존 로직 실행
      // const { requestProcess } = this.$route.query
      // if ([true, 'true'].includes(requestProcess)) {
      //   await this.request()
      // }

      await this.getLoanAvailableTime()
    } catch (error) {
      console.error('사전 체크 중 오류 발생:', error)
    }
  },
  methods: {
    commaFormat,
    ...mapActions('loan', ['getLoanAvailableTime', 'updateOffer']),
    ...mapActions('evaluation', [
      'isKcsAgreements',
      'isHometaxAccounts',
      'getCreditEvaluationsCurrent',
    ]),

    handleOfferUpdate(offer) {
      this.updateOffer(offer) // Store the offer in Vuex
    },

    /**
     * 대출 신청
     */
    async request() {
      await this.$router.push('/loan/pull-revenue-check')
    },
    async validateUserRequirements1() {
      /*      
      // 홈텍스 계정 체크
      if (!(await this.isHometaxAccounts())) {
        return this.$router.replace({
          path: '/auth/accounts/hometax',
          query: { next: '/loan/pull-revenue' },
        })
      }

      // KCS 약관 동의 체크
      if (!(await this.isKcsAgreements())) {
        return this.$router.replace({
          path: '/signup/agreements/kcs',
          query: { next: '/loan/pull-revenue' },
        })
      }
*/
      // 신용평가 데이터 체크
      const creditData = await this.getCreditEvaluationsCurrent()
      if (Object.keys(creditData).length === 0) {
        return this.$router.replace({
          path: '/factoring/confirm',
          query: {
            next: '/loan/pull-revenue',
            redirectPath: '/loan/pull-revenue',
          },
        })
      }
    },
  },
  components: { GetOffer: () => import('@/components/loan/GetOffer.vue') },
}
</script>
